import { GetTrimLevels_trimLevels } from '../graphql/queries/__generated__/GetTrimLevels';
import urlRoute from '../../common/service/urlRoute';
import { ROUTES } from '../../common/constants/routes';
import * as queryString from 'query-string';
import { GetTrimDetail } from '../graphql/queries/__generated__/GetTrimDetail';
import trimLevels from '../constants/trimLevels';
import { ITrimSelectedLevel } from '../model/ITrimSelectedLevel';
import { Filters } from '../../__generated__/globalTypes';
import fieldCheckerService from './fieldCheckerService';

interface ITrimLabelAttribute {
  attributes: { shortname: string };
}

interface INextTrimLevel {
  newIndex: number;
  searchParams?: { [key: string]: string };
}

const trimLevelsService = {
  extendTrimLevelQuery: (trimLevels: GetTrimLevels_trimLevels[], activeTrimIndex: number) =>
    trimLevels.map((trimLevel, index) => ({
      ...trimLevel,
      name: trimLevel.type,
      disabled: index > activeTrimIndex,
    })),

  getNextTrimLevelPath: (
    trimCode: string,
    trimTypesList: string[],
    activeTrimIndex: number,
    queryParams: Record<string, string>,
  ) => {
    let pathname = urlRoute.createUrl(ROUTES.CONFIGURE_GQL, { trimCode });
    if (trimTypesList.length > activeTrimIndex + 1) {
      pathname = `${ROUTES.TRIM_LEVELS_BASE}${trimCode}/${trimTypesList[activeTrimIndex + 1]}`;
    }

    return { pathname, search: queryString.stringify(queryParams) };
  },

  getCurrentSelectedLevels: (data: GetTrimDetail): ITrimSelectedLevel[] => {
    return Object.keys(data).reduce((acc, key) => {
      if (data[key as keyof GetTrimDetail] && key !== trimLevels.TRIM) {
        return [...acc, { key, value: (data[key as keyof GetTrimDetail] as ITrimLabelAttribute).attributes.shortname }];
      }

      return acc;
    }, [] as ITrimSelectedLevel[]);
  },
  getNextTrimLevelIndex: (trimTypesList: string[], currentIndex: number, nextFilters: Filters): INextTrimLevel => {
    let newIndex = currentIndex;
    const searchParams: { [key: string]: string } = {};

    while (newIndex < trimTypesList.length - 1) {
      const filterCode = fieldCheckerService.switchAndReturnField(trimTypesList[newIndex]);

      if (!nextFilters || !nextFilters[filterCode]) {
        break;
      }

      searchParams[trimTypesList[newIndex]] = nextFilters[filterCode];
      newIndex++;
    }

    return { newIndex, searchParams };
  },
};

export default trimLevelsService;
